var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResendIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 14.1725C18.3318 14.3914 18.2443 14.6008 18.0896 14.7557C17.9349 14.9105 17.7255 14.9983 17.5067 15H2.49333C2.27401 14.9998 2.06375 14.9125 1.90874 14.7573C1.75374 14.6022 1.66667 14.3918 1.66667 14.1725V13.3333H16.6667V3.58333L10 9.58333L1.66667 2.08333V0.833333C1.66667 0.61232 1.75446 0.400358 1.91074 0.244078C2.06702 0.0877973 2.27899 0 2.5 0H17.5C17.721 0 17.933 0.0877973 18.0893 0.244078C18.2455 0.400358 18.3333 0.61232 18.3333 0.833333V14.1725ZM3.695 1.66667L10 7.34167L16.305 1.66667H3.695ZM0 10H6.66667V11.6667H0V10ZM0 5.83333H4.16667V7.5H0V5.83333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendIcon);
export default __webpack_public_path__ + "static/media/resend-icon.dd3385edb4a69d4b143b4a0d6c4826e3.svg";
export { ForwardRef as ReactComponent };